import { ILogin } from "@/iti-core-react/interfaces/ILogin";
import { ItiHttpService } from "@/iti-core-react/services/iti-http-service";
import { ItiTokenService } from "@/iti-core-react/services/iti-token-service";
import { UserDto } from "@/shared/dtos/user-dto";
import { API } from "../api";

enum GrantType {
	Password = "password",
	RefreshToken = "refresh_token",
}

const onLogin = (res: any) => {
	if (res.access_token) {
		return ItiTokenService.setToken(
			res.access_token,
			res.refresh_token,
			res.expires_in,
			res.refresh_expires_in,
		);
	}
	return false;
};

const onLoginFail = () => {
	return false;
};

const initTokenRequestParams = (grantType: string) => {
	const params = new URLSearchParams();

	params.append("client_id", import.meta.env.VITE_KEYCLOAK_CLIENT_ID as string);
	params.append(
		"client_secret",
		import.meta.env.VITE_KEYCLOAK_CLIENT_SECRET as string,
	);
	params.append("grant_type", grantType);

	return params;
};

export const AuthorizationService = {
	async login(login: ILogin) {
		try {
			const params = initTokenRequestParams(GrantType.Password);
			params.append("username", login.UserName);
			params.append("password", login.Pwd);

			const res = await ItiHttpService.postxWwwFormUrlencoded(
				API.login,
				params,
				true,
				false,
				false,
			);
			return await onLogin(res);
		} catch (err) {
			return onLoginFail();
		}
	},
	async registerUser(user: UserDto) {
		try {
			user.username = "";
			user.group = "";
			user.tenant = "";

			return ItiHttpService.post(
				API.centralizedAuth.users,
				user.toJson([
					"id",
					"originalJson",
					"visible",
					"confirmPassword",
					"username",
					"group",
					"tenant",
				]),
				true,
				false,
				true,
			).then((res: any) => {
				return res
					? this.login({ UserName: user.email, Pwd: user.password })
					: null;
			});
		} catch (err) {
			return false;
		}
	},
	logout() {
		ItiTokenService.clearToken();
	},
	loggedIn(): boolean {
		return ItiTokenService.hasToken();
	},
	async refreshToken() {
		try {
			const params = initTokenRequestParams(GrantType.RefreshToken);
			params.append(GrantType.RefreshToken, ItiTokenService.getRefreshToken());

			const res = await ItiHttpService.postxWwwFormUrlencoded(
				API.login,
				params,
				false,
			);
			return onLogin(res);
		} catch (err) {
			return onLoginFail();
		}
	},
	async startRefreshTokenTask(signOut: () => void, setRefreshTokenTask: any) {
		if (!ItiTokenService.areTokensExpired()) {
			return setTimeout(async () => {
				await AuthorizationService.refreshToken().then((res: boolean) => {
					if (!res) {
						signOut();
					}
				});
				setRefreshTokenTask(undefined);
			}, ItiTokenService.getMillisecondsUntilExpiration() - 5000);
		}
		return null;
	},
};
